import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';

export type TipoEvento =
  | 'nav_start' | 'nav_end' | 'nav_cancel' | 'nav_error'
  | 'page_view' | 'page_params' | 'page_fragment';

export interface AuditRecurso { tipo: string; id: string; titulo?: string; }
export interface AuditPayload {
  tipoevento: TipoEvento;
  recurso?: AuditRecurso;     
  origem?: string;            
  caminho?: string;           
  metodo?: string;            
  codigostatus?: number;      
}

@Injectable({ providedIn: 'root' })
export class AuditService {
  private readonly apiUrl = `${environment.apiBaseUrl}/api/auditoria`;
  
  constructor(private readonly http: HttpClient) {}

  submitAudit(audit: AuditPayload): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    // O interceptor Autenticacao adiciona o token automaticamente se a URL estiver protegida
    return this.http.post(this.apiUrl, audit, { headers }).pipe(
      catchError((error) => {
        console.error('❌ [AUDIT] Erro ao enviar auditoria:', error);
        return of(null); // Não interrompe o fluxo em caso de erro
      })
    );
  }
}
